import React from 'react';
import Select from "components/elements/form/select/Select";
import Option from "components/elements/form/select/Option";

type Props = {
    currency: string;
    setCurrency: any;
};

export default function CurrencySwitcher(props: Props) {
    return (
        <Select
            className={`bg-primary-25 lg:inline-flex cursor-pointer`}
            name={"currency-switcher"}
            onChange={(event: any) => props.setCurrency(event.target.value)}
            value={props.currency}
        >
            <Option label={"€ EUR"} value={"EUR"}/>
            <Option label={"£ GBP"} value={"GBP"}/>
        </Select>
    );
}

